
import { Product} from "@/models/base";
import Vue from "vue";
import AppPriceRuleEditList from "@/components/price-rules/PriceRuleEditList.vue";
import { ProductPriceRule } from "@/models/base/product-price-rule";

export default Vue.extend({
	props: {
		product: {
			type: Object as ()=>Product,
			required: true
		}
	},
	computed: {
		newRuleConstructor():()=>ProductPriceRule {
			return ()=>new ProductPriceRule();
		}
	},
	components: {
		AppPriceRuleEditList
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
